import { createDomain } from 'effector';

const domain = createDomain('set-virtual-licence-task-category-group-list-modal');

if (process.env.NODE_ENV === 'development') {
    // @ts-ignore
    import('effector-logger/attach').then((module) => module.attachLogger(domain));
}

export default domain;
